// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/apps/catalog_subscriptions_list_datatable" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsCatalogSubscriptionsListDatatable } from "./constants";
import type {
  AppsCatalogSubscriptionsListDatatableParams,
  AppsCatalogSubscriptionsListDatatableResult,
} from "./types";

export const getDataTableAppsCatalogSubscriptionsListDatatable = reactQueryTableFetcherAdapter(
  appsCatalogSubscriptionsListDatatable,
  (
    signal: AbortSignal,
    {
      appGroupId,
      catalogId,
      groupby,
      limit,
      query = {},
      sortby,
      sortdir,
      start = 0,
    }: AppsCatalogSubscriptionsListDatatableParams
  ): Promise<AppsCatalogSubscriptionsListDatatableResult> => {
    return fetch(
      `/apps/catalog_subscriptions_list_datatable`,
      "GET",
      {
        app_group_id: appGroupId,
        catalog_id: catalogId,
        groupby,
        limit,
        query: serializeQueryObjects(query),
        sortby,
        sortdir,
        start,
      },
      { signal }
    );
  }
);
